import React from 'react';
import { Shield, Home } from 'lucide-react';
import SEO from '../components/SEO';
import Button from '../components/Button';

export default function NotFound() {
  return (
    <div className="bg-canvas min-h-[70vh] flex items-center justify-center py-20 px-4">
      <SEO title="Page Not Found | UMED" />
      <div className="max-w-md w-full text-center space-y-6">
        <div className="w-16 h-16 rounded-2xl bg-[#F5FAF9] text-[#0F766E] flex items-center justify-center mx-auto border border-[#D9E8E5]">
          <Shield className="w-8 h-8 text-[#0F766E]" />
        </div>
        <span className="text-xs uppercase tracking-widest text-[#0F766E] font-bold">
          404 &bull; Page Not Found
        </span>
        <h1 className="font-serif text-3xl sm:text-4xl text-[#123B5D] font-normal">
          The requested page could not be located.
        </h1>
        <p className="text-xs sm:text-sm text-[#64748B] leading-relaxed">
          The page you are looking for may have been moved, updated, or does not exist. Please navigate back to our healthcare portal.
        </p>
        <div className="pt-4 flex items-center justify-center gap-4">
          <Button to="/" variant="primary" size="md">
            <Home className="w-4 h-4 mr-2" />
            Return to Home
          </Button>
          <Button to="/services" variant="secondary" size="md">
            View Services
          </Button>
        </div>
      </div>
    </div>
  );
}
